export function saveRowToDb(entity, row) {
  sendRequest(`/${entity}s/${row.id}.json`, { "id": row.id, "name": row.name}, function(response) {}, function(response) {}, 'PUT', false)	
}

export async function deleteRowFromDb(entity, row) {
  await fetch(`/api/rows/${row.id}`, { method: "DELETE" })
}

export function update_server(entity, original, field, current, previous) {
  fetch(`/${entity}s/${original.id}.json`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    },
    body: JSON.stringify({
      [entity]: {
        [field]: current.value
      }
    })
  })
  .then(async response => {
    const data = await response.json();

    if (!response.ok) {
      alert("Fehler:\n" + (data?.base?.join("\n") || "Unknown error"));
      current.value = previous; // rollback
      throw new Error(data.base?.join(", ") || "Fehler");
    }

    original[field] = current.value; // persist on success
    return data;
  })
  .catch(error => {
    console.error("Error:", error);
  });
}

export function formatForDateInput(dateStr) {
  return dateStr ? new Date(dateStr).toISOString().slice(0, 10) : ''
}

export function isHttpSuccess(xhr) {
    return xhr.status >= 200 && xhr.status < 300;
}

export function sendRequest(url, params, onSuccess, onFailure, method='POST', synch = false) {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url, synch); // false for synchronous

  xhr.setRequestHeader('Content-Type', 'application/json');
  var token = document.querySelector('meta[name="csrf-token"]').content;
  xhr.setRequestHeader('X-CSRF-Token', token);
  
  console.log("sendRequest params=" + JSON.stringify(params));
  xhr.send(JSON.stringify(params));

  //console.log("xhr repsonse text=" + xhr.responseText);
  const response = JSON.parse(xhr.responseText);
  if (isHttpSuccess(xhr)) {
    console.log(response); // Handle successful creation
    onSuccess(response);
    return true;
  } else {
	onFailure(response);
    return false;
  }
}

export function transparent(color, alpha) {
  // Supports #rgb or #rrggbb
  const hex = color.replace('#', '');
  const bigint = parseInt(hex.length === 3
    ? hex.split('').map(c => c + c).join('')
    : hex,
  16);

  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// Die Projektfarben in der Datenbank sind durchweg helle Pastelltoene. Als
// gefuellter Balken funktionieren sie, als duenne Linie oder als 12-px-Text auf
// hellem Grund nicht: gemessen liegen alle 30 Farben bei einem Kontrast von
// 1,14:1 bis 2,99:1, lesbar wird Text ab 4,5:1. Deshalb fuer Rahmen und Zahlen
// des aufgeklappten Projekts (TIM-61) den Farbton behalten und nur die
// Helligkeit senken, bis der Kontrast reicht.
//
// Bezugsflaeche ist der Abschnittshintergrund - die Projektfarbe mit 20 Prozent
// Deckung auf Weiss -, weil der Kopfbalken keine eigene Fuellung mehr hat.
export function readableProjectColor(color, target = 4.5) {
  const [r, g, b] = hexToRgb(color);
  const background = [r, g, b].map(c => Math.round(c * 0.2 + 255 * 0.8));

  const [h, l, s] = rgbToHsl(r, g, b);
  // In 100 Schritten abdunkeln und den ersten Ton nehmen, der reicht. Reicht
  // keiner, bleibt Schwarz - der dunkelste mit dem hoechsten Kontrast.
  for (let step = 0; step <= 100; step++) {
    // Vor dem Pruefen runden, sonst gilt ein Kontrast, den die ausgegebene
    // Hex-Farbe knapp verfehlt.
    const candidate = hslToRgb(h, l * (1 - step / 100), s).map(Math.round);
    if (contrast(candidate, background) >= target) return rgbToHex(candidate);
  }
  return '#000000';
}

function hexToRgb(color) {
  const hex = color.replace('#', '');
  const full = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex;
  const bigint = parseInt(full, 16);
  return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
}

function rgbToHex([r, g, b]) {
  return '#' + [r, g, b].map(c => Math.round(c).toString(16).padStart(2, '0')).join('');
}

function rgbToHsl(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  const l = (max + min) / 2;
  if (max === min) return [0, l, 0];

  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  let h;
  if (max === r)      h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
  else if (max === g) h = ((b - r) / d + 2) / 6;
  else                h = ((r - g) / d + 4) / 6;
  return [h, l, s];
}

function hslToRgb(h, l, s) {
  if (s === 0) return [l * 255, l * 255, l * 255];

  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const channel = (t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  };
  return [channel(h + 1 / 3) * 255, channel(h) * 255, channel(h - 1 / 3) * 255];
}

// Relative Leuchtdichte und Kontrastverhaeltnis nach WCAG 2.
function luminance([r, g, b]) {
  const [rr, gg, bb] = [r, g, b].map(v => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * rr + 0.7152 * gg + 0.0722 * bb;
}

function contrast(a, b) {
  const la = luminance(a), lb = luminance(b);
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}
